<template>
  <div class="ht-page-header">
    <div class="ht-page-header__text">
      <h2 class="ht-page-header__title">{{ title }}</h2>
      <p v-if="subtitle" class="ht-page-header__subtitle">{{ subtitle }}</p>
      <slot></slot>
    </div>
    <div v-if="$scopedSlots.actions" class="ht-page-header__actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
// Page title band: title, optional description, optional breadcrumbs (default slot)
// and page-level actions (#actions slot). Presentation only.
export default {
  name: "PageHeader",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
  },
};
</script>

<style scoped>
.ht-page-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px 16px;
  padding: 14px 20px;
  background: linear-gradient(100deg, #dde7ee 0%, #f3f7fa 45%, #ffffff 100%);
  border-bottom: 1px solid var(--ht-border, #e1e6eb);
}

.ht-page-header::before {
  content: "";
  position: absolute;
  left: 0;
  top: 18px;
  bottom: 18px;
  width: 4px;
  border-radius: 0 4px 4px 0;
  background: #6cb8dc;
}

.ht-page-header::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -1px;
  height: 2px;
  background: linear-gradient(90deg, #4d7082, #6cb8dc, transparent 75%);
  opacity: 0.55;
}

.ht-page-header__text {
  min-width: 0;
}

.ht-page-header__title {
  margin: 0;
  font-size: 1.375rem;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: -0.01em;
  color: var(--ht-text, #1f2d3d);
}

.ht-page-header__subtitle {
  margin: 2px 0 0;
  font-size: 0.8125rem;
  color: var(--ht-text-muted, #637381);
}

.ht-page-header__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

@media (max-width: 599px) {
  .ht-page-header {
    padding: 14px 16px;
  }

  .ht-page-header__title {
    font-size: 1.125rem;
  }
}
</style>
